import PropTypes from "prop-types";

import useStudentPreviewContext from "@/view/utils/useStudentPreviewContext";
import usePollContext from "@/view/utils/usePollContext";
import { rootCss } from "./PollContainer.style";
import StudentPollContainer from "./StudentPollContainer";
import TeacherPollContainer from "./TeacherPollContainer";

const propTypes = {
  contentType: PropTypes.string,
  currentContentLevelId: PropTypes.string,
  isStudentAssignmentEmbedActive: PropTypes.bool,
  isPremiumContent: PropTypes.bool,
  levelId: PropTypes.string,
  openAssignmentEditor: PropTypes.func,
  selectedAssignmentId: PropTypes.string,
  userId: PropTypes.string,
  userProperties: PropTypes.object,
};

const PollContainer = ({
  contentType,
  currentContentLevelId,
  isStudentAssignmentEmbedActive,
  isPremiumContent,
  levelId,
  openAssignmentEditor,
  selectedAssignmentId,
  userId,
  userProperties,
}) => {
  const { isLiteUser, isStudent, isTeacher } = userProperties;
  const {
    activePoll,
    isPollSelected,
    setAssignedPoll,
    pollTemplates,
    inViewRef,
  } = usePollContext();
  const { isStudentPreviewOn } = useStudentPreviewContext();
  const isTemplatePoll = activePoll?.is_template;

  if (!activePoll) return null;

  const renderPoll = () => {
    if (isTeacher) {
      if (isStudentPreviewOn && isPollSelected) {
        return (
          <StudentPollContainer
            activePoll={activePoll}
            contentType={contentType}
            isTeacher={isTeacher}
            levelId={levelId}
          />
        );
      } else {
        return (
          <TeacherPollContainer
            contentType={contentType}
            currentContentLevelId={currentContentLevelId}
            isStudentAssignmentEmbedActive={isStudentAssignmentEmbedActive}
            isLiteUser={isLiteUser}
            isPremiumContent={isPremiumContent}
            levelId={levelId}
            openAssignmentEditor={openAssignmentEditor}
            polls={pollTemplates}
            selectedAssignmentId={selectedAssignmentId}
          />
        );
      }
    } else if (isStudent && !isTemplatePoll) {
      return (
        <StudentPollContainer
          activePoll={activePoll}
          contentType={contentType}
          levelId={levelId}
          setAssignedPoll={setAssignedPoll}
          userId={userId}
        />
      );
    }
  };

  return (
    <div css={rootCss} ref={inViewRef}>
      {renderPoll()}
    </div>
  );
};

PollContainer.propTypes = propTypes;

export default PollContainer;
